import React from 'react';

const ModeloNumerario = React.createContext();

export default ModeloNumerario;
